import React from 'react';
import { render } from 'react-dom';

class Badge extends React.Component {

    getQuantity() {
        var quantity = "";
        if (this.props.quantity > 0) {
            if (this.props.quantity >= 100) {
                quantity = "99+";
            }
            else {
                quantity = this.props.quantity;
            }
        }
        return quantity;
    }

    render() {
        var qty = this.getQuantity();
        return (
            qty !== "" ? <span className="badge pull-right">{qty}</span> : ""
        );
    }
}
export default Badge;  